<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Gerenciar Caixa' | translate}}</ion-title>
  </ion-buttons>
</ion-header>


<ion-content padding>
  <div class="gradient-extendido"></div>

  <ion-card class="gradient-extendido-recuo" *ngIf="grupoCaixa.id">
    <ion-card-content class="align-center">
      <div>
        <label>
          <p class="labelAtual bold-1">{{'Saldo Atual' | translate}}</p>
        </label>
      </div>

      <div>
        <label class="valorAtual"
          [ngClass]="{'green': grupoCaixa.saldoAtual > 0, 'red': grupoCaixa.saldoAtual < 0, 'blue': grupoCaixa.saldoAtual == 0}">{{
          grupoCaixa.saldoAtual | money | async}}</label>
      </div>
    </ion-card-content>
  </ion-card>

  <div *ngIf="grupoCaixa.id">
    <ion-grid>
      <ion-row>
        <ion-col size="4" (click)="abrirLancamento('E')">
          <ion-button class="custom-button">
            <ion-label>
              <i class="fas fa-sign-out-alt green"></i>

              <p>{{'Entradas' | translate}}</p>
            </ion-label>
          </ion-button>
        </ion-col>

        <ion-col size="4" (click)="abrirLancamento('S')">
          <ion-button class="custom-button">
            <ion-label>
              <i class="fas fa-sign-in-alt red"></i>

              <p> {{'Saídas' | translate}}</p>
            </ion-label>
          </ion-button>
        </ion-col>

        <ion-col size="4" (click)="abrirTransferencia('T')">
          <ion-button class="custom-button">
            <ion-label>
              <i class="fas fa-exchange-alt blue"></i>

              <p>{{'Transferir' | translate}}</p>
            </ion-label>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <div class="gradient-extendido-div" *ngIf="grupoCaixa.id">
    <div class="div-top">
      <ion-note slot="start">
        <i class="fas fa-receipt div-icon" style="margin-top: 2px;"></i>
      </ion-note>

      <ion-label class="color-title">
        {{'Últimos Lançamentos' | translate}}
      </ion-label>
    </div>

    <ion-card-content class="remove-border remove-card pointer">
      <div *ngIf="lancamentos.length">
        <ion-list class="lista-grupo" *ngFor="let l of lancamentos">
          <ion-item  (click)="detalhesLancamento(l)">             
            <ion-label [ngClass]="{
              'border-1' : l.grupoCaixaItem && l.grupoCaixaItem.tipo == 'S',
              'border-2' : l.grupoCaixaItem && l.grupoCaixaItem.tipo == 'E',
              'border-3' : !l.grupoCaixaItem
            }">
              <h2 class="bold">{{l.valor | money | async}}</h2>

              <p *ngIf="l.grupoCaixaItem">
                {{l.grupoCaixaItem.nome}}
              </p>

              <p *ngIf="!l.grupoCaixaItem">
                {{'TRANSFERÊNCIA' | translate}}
              </p>

              <p *ngIf="l.pessoaVinculo">
                {{l.pessoaVinculo.nome}}
              </p>

              <p *ngIf="l.descricao">
                {{l.descricao}}
              </p>

              <p class="bold">
                {{l.dataLancamento | dateFormat:'ddmmyyyy' }}
              </p>
            </ion-label>

            <ion-note slot="end">
              <i *ngIf="l.grupoCaixaItem && l.grupoCaixaItem.tipo == 'S'" class="fas fa-sign-in-alt red"></i>

              <i *ngIf="l.grupoCaixaItem && l.grupoCaixaItem.tipo == 'E'" class="fas fa-sign-out-alt green"></i>

              <i *ngIf="!l.grupoCaixaItem" class="fas fa-exchange-alt blue"></i>

              <p *ngIf="l.lancamentoOfertas && l.lancamentoOfertas.idLancamento">
                <ion-icon class="green" name="checkmark"></ion-icon>
              </p>
            </ion-note>
          </ion-item>
        </ion-list>
      </div>

      <sem-registro *ngIf="!lancamentos.length">
      </sem-registro>

      <ion-infinite-scroll (ionInfinite)="loadLancamentos($event)"
        *ngIf="pagination.currentPage < pagination.pageCount">
        <ion-infinite-scroll-content loadingText="(Carregando | translate)..."></ion-infinite-scroll-content>
      </ion-infinite-scroll>

    </ion-card-content>
  </div>
</ion-content>